import { send } from 'server';

export const getGameZoneCollection = () => send({
    ID: 35216,
    responses: [35217, 35218],
    description: 'Get Game Zone Collection'
});
